import type { LinkError } from "./accountLinkPort.js";

export function firebaseErrorCode(error: unknown): string {
  if (error && typeof error === "object" && "code" in error) {
    const code = (error as { code: unknown }).code;
    if (typeof code === "string") return code;
  }
  return "";
}

export function mapLinkError(code: string): LinkError {
  switch (code) {
    case "auth/credential-already-in-use":
    case "auth/email-already-in-use":
    case "auth/account-exists-with-different-credential":
      return { code: "alreadyInUse", messageKey: "settings.linkAccount.errorInUse" };
    case "auth/popup-closed-by-user":
    case "auth/cancelled-popup-request":
    case "auth/user-cancelled":
      return { code: "cancelled", messageKey: "" };
    case "auth/popup-blocked":
      return { code: "popupBlocked", messageKey: "settings.linkAccount.errorGeneric" };
    case "auth/network-request-failed":
      return { code: "network", messageKey: "settings.linkAccount.errorGeneric" };
    case "auth/no-current-user":
      return { code: "noCurrentUser", messageKey: "settings.linkAccount.errorGeneric" };
    default:
      return { code: "unknown", messageKey: "settings.linkAccount.errorGeneric" };
  }
}
